<template>
    <div class="loader" v-show="loading">...loading</div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    loading: {
      type: Boolean,
      request: true,
    },
  },
};
</script>

<style scoped>
</style>
